import React from "react";
import { generateLines, generatePoints, isMobileDevice } from "../../Utils/Utils";
import { Point } from "../../Utils/types";

const GlobalLoader: React.FC = () => {
  const numPoints = isMobileDevice() ? 15 : 30; // Random number of points between 30 and 50
  const initialSpeed = 0.2; // Adjust this value to control the initial movement speed
  const circlePoints: Point[] = generatePoints({ numPoints, initialSpeed });
  const lines = generateLines(circlePoints, "rgba(255, 255, 255, 0.10)");

  return (
    <div className="page-loader">
      <div className="background"></div>
      <svg className="web" xmlns="http://www.w3.org/2000/svg">
        <g className="lines">{lines}</g>
        {circlePoints.map((point, index) => (
          <circle
            key={index}
            cx={`${point.x}%`}
            cy={`${point.y}%`}
            r={3}
            fill="rgba(255, 255, 255, 0.45)"
            className="moving-point"
          />
        ))}
      </svg>
      <div className="center">
        <div className="spinner"></div>
        <div className="letter"></div>
      </div>
    </div>
  );
};

export default GlobalLoader;
